import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FormParams } from '../../../interfaces/form-params';
import { BmCache } from '../../../../data-access/services/bm-cache.service';

@Component({
  selector: 'bm-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;



  options: any[] = [];

  constructor(private cache: BmCache) {}


  async ngOnInit() {

    this.options = await this.cache.loadEnums(this.params.params.optionsKeyword);

    console.log(this.params, this.options, ' <<<<<<<<<<<<<<');

    if (this.params.compactValue) {

      const ids = this.params.compactValue.split(',').map(id => +id);
      this.params.value = this.options.filter(option => {
        const idKey = Object.keys(option).find(key => key.startsWith('_'));
        return ids.includes(option[idKey]);
      });

    }
  }

}
